import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LEAD_SOURCE_ACTION_TYPE } from '../actions';

const initialState = {};

const leadSourcesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LEAD_SOURCE_ACTION_TYPE.GET_LEAD_SOURCES:
        return payload || {};

      case LEAD_SOURCE_ACTION_TYPE.ADD_LEAD_SOURCE:
      case LEAD_SOURCE_ACTION_TYPE.EDIT_LEAD_SOURCE:
        draft[payload.leadSourceId] = payload;
        break;

      case LEAD_SOURCE_ACTION_TYPE.DELETE_LEAD_SOURCE:
        delete draft[payload];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default leadSourcesReducer;
